import { render } from "./users-blockages.vue?vue&type=template&id=44084804"
import script from "./users-blockages.vue?vue&type=script&setup=true&lang=js"
export * from "./users-blockages.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/users/users-blockages.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44084804"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44084804', __exports__)) {
    api.reload('44084804', __exports__)
  }
  
  module.hot.accept("./users-blockages.vue?vue&type=template&id=44084804", () => {
    api.rerender('44084804', render)
  })

}


export default __exports__